export class Units {
    public static get units(): Object {
        return {
            KG: 'kg',
            UNIT: 'unit',
            UNITS: 'units'
        };
    }
}
